import React from 'react';
import styled from 'styled-components';
import {AccentColorOptions} from 'epic-ue-theme';
import {Button, CmsButtonProps, Eyebrow, EyebrowProps, Typography, VerticalSpacer} from '..';

const PluginCardWrapper = styled.div`
    && {
        .paragraph.caption {
            color: ${(p) =>
                p.theme.ifLight(p, 'theme.palette.neutral.steel', 'theme.palette.neutral.stone')};
        }

        .plugin-card-content {
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            align-content: center;
            justify-content: space-between;
            align-items: center;

            width: 100%;
            max-width: none;
            height: 438px;
            text-align: center;
            padding: ${(p) => p.theme.spacing(6)}px 0;
            ${(p) => p.theme.breakpoints.down('sm')} {
                padding: ${(p) => p.theme.spacing(3)}px 0;
                height: unset;
                min-height: 350px;
            }
        }

        .plugin-card-content-group {
            padding: 0 ${(p) => p.theme.spacing(6)}px;
        }
    }
`;

export interface PluginCardProps {
    accentColor?: AccentColorOptions;
    eyebrow?: EyebrowProps;
    title?: string;
    button?: CmsButtonProps;
    description?: string;
    os?: string;
}

export const PluginCard = ({
    accentColor = 'sky',
    eyebrow,
    title,
    button,
    description
}: PluginCardProps): JSX.Element => {
    return (
        <PluginCardWrapper>
            <div className="plugin-card-content">
                {eyebrow && eyebrow.text && (
                    <div className="plugin-card-content-group">
                        <Eyebrow {...eyebrow} />
                    </div>
                )}

                <div className="plugin-card-content-group">
                    {title && (
                        <>
                            <Typography variant="h2">{title}</Typography>
                            <VerticalSpacer variant="custom" spacing={2} />
                        </>
                    )}

                    {description && (
                        <>
                            <Typography variant="p" caption accentColor={accentColor}>
                                {description}
                            </Typography>
                        </>
                    )}
                </div>

                <div className="plugin-card-content-group">
                    {button && button.label && (
                        <Button
                            type={'primary'}
                            color={accentColor}
                            href={button.href}
                            target={button.target}>
                            {button.label}
                        </Button>
                    )}
                </div>
            </div>
        </PluginCardWrapper>
    );
};
